import React, { useState, useContext, useEffect } from 'react';
import { CreditCard, Mail, User } from 'lucide-react';
import axios from 'axios';
import AppContext from '../../context/AppContext';
import { saveTransactionData } from '../../db/transactions/saveTransactionData';
import { updateVendeurInfo } from '../../db/users/updateVendeurInfo';
import { database, ref, set } from '../../FirebaseConfig';

import { useNavigate } from 'react-router-dom';
const IndexPaiement = () => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const [montant, setMontant] = useState(100);
  const { isSplashVisible, isLoading, id, unProduit, allAggregators } = useContext(AppContext);
  const [selectedAggregator, setSelectedAggregator] = useState(null);
  const [apiKey, setApiKey] = useState(null);

  const navigate = useNavigate()

  // Récupération des paramètres de l'URL
  const searchParams = new URLSearchParams(window.location.search);
  const aggregatorId = searchParams.get('id'); // ID de l'agrégateur (nom)

  // Récupérer les informations de l'agrégateur sélectionné directement depuis la structure
  useEffect(() => {
    if (allAggregators && aggregatorId) {
      // Accès direct à l'agrégateur par son ID (nom)
      const aggregator = allAggregators[aggregatorId];
      
      if (aggregator) {
        console.log(`Agrégateur trouvé: ${aggregator.name}`, aggregator);
        setSelectedAggregator(aggregator);
        
        // Récupérer la clé API
        if (aggregator.requiredKeys && aggregator.requiredKeys.includes('apiKey')) {
          setApiKey(aggregator.apiKey);
          console.log("Clé API trouvée:", aggregator.apiKey);
        }
      } else {
        console.error(`Aucun agrégateur trouvé avec l'ID: ${aggregatorId}`);
        setStatus({
          type: 'error',
          message: 'Méthode de paiement non trouvée. Veuillez réessayer.'
        });
      }
    }
  }, [allAggregators, aggregatorId]);

  const [formData, setFormData] = useState({
    amount: '',
    email: '',
    first_name: '',
    last_name: '',
    idGroup: '',
    idVendeur: '',
    idClient: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    if (!selectedAggregator) {
      setStatus({
        type: 'error',
        message: 'Méthode de paiement non disponible. Veuillez réessayer.'
      });
      setLoading(false);
      return;
    }
    
    try {
      // Format adapté à notre backend (voir api_routes.py)
      const paymentData = {
        amount: 100,
        type_requete: "abonnement_mensuel", // Pour indiquer un abonnement mensuel et non un groupe
        user_id: String(id), // ID utilisateur
        customer_email: formData.email,
        customer_first_name: formData.first_name || "Client",
        customer_last_name: formData.last_name || "Kapella"
        // NE PAS inclure 'method' ou 'methods' du tout
        // Cela permettra à payment_methods de rester None dans le backend
      };
      
      console.log("Données de paiement:", paymentData);
      console.log("Utilisation de l'agrégateur:", selectedAggregator.name);
      
      // URL du backend
      const backendUrl = `${process.env.REACT_APP_BACKEND_URL || "https://api.kapella.com"}${process.env.REACT_APP_MONEROO_CREATE_ENDPOINT || "/api/payment/moneroo/create"}`;
      
      console.log("Appel du backend pour création du paiement Moneroo:", backendUrl);
      
      let response;
      
      // Faire un vrai appel API
      response = await axios.post(
        backendUrl,
        paymentData,
        {
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
            // Suppression des en-têtes CORS qui doivent être configurés côté serveur
            // et non côté client
          }
        }
      );
      
      // Pour déboguer, log les données qui auraient été envoyées
      console.log("Données qui auraient été envoyées à:", backendUrl);
      console.log("Payload:", paymentData);
      
      // NOTE: Le problème CORS a été résolu, nous utilisons désormais ce code correct
      // Nous avons supprimé les en-têtes CORS côté client car ils doivent être configurés
      // uniquement côté serveur pour fonctionner correctement
      
      console.log("Réponse du backend:", response.data);
      
      // Vérifier que nous avons reçu un statut de succès
      if (response.data.status !== 'success') {
        throw new Error(response.data.message || "Erreur lors de la création du paiement");
      }
      
      // Extraire l'URL de paiement et l'ID de transaction
      if (response.data.payment_url) {
        const paymentUrl = response.data.payment_url;
        const paymentId = response.data.payment_id;
        const transactionId = response.data.transaction_id;
        
        console.log(`Redirection vers ${paymentUrl} avec ID de paiement ${paymentId}`);
        console.log("Transaction ID:", transactionId);
        
        // Vérifier si l'URL est une URL de test ou une vraie URL
        if (paymentUrl.includes('mp_test')) {
          // C'est une URL de test, redirigeons directement vers notre page de statut
          navigate(`/MonerooPaymentStatus?payment_id=${paymentId}`);
        } else {
          // C'est une vraie URL, redirigeons l'utilisateur
          window.location.href = paymentUrl;
        }
      } else {
        throw new Error("URL de paiement non fournie par le service");
      }
    } catch (error) {
      console.error("Erreur lors de l'initialisation du paiement:", error);
      
      // Ajouter des détails supplémentaires pour le débogage CORS
      if (error.message === 'Network Error') {
        setStatus({ 
          type: 'error', 
          message: 'Erreur réseau - Problème CORS possible. Contactez l\'administrateur.'
        });
      } else {
        setStatus({ 
          type: 'error', 
          message: error.response?.data?.message || 'Erreur lors de l\'initialisation du paiement'
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClick = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    if (!selectedAggregator) {
      setStatus({
        type: 'error',
        message: 'Méthode de paiement non disponible. Veuillez réessayer.'
      });
      setLoading(false);
      return;
    }
    
    // Vérifier si c'est FedaPay
    if (selectedAggregator.name === 'fedapay' && window.FedaPay) {
      try {
        const widget = window.FedaPay.init({
          public_key: selectedAggregator.apiKey || apiKey, // Utiliser la clé API de l'agrégateur
          transaction: {
            amount: 100,
            description: 'Paiement abonnement Premium',
          },
          customer: {
            lastname: formData.last_name || 'Client',
            firstname: formData.first_name || 'Kapella',
            email: formData.email,
          },
          onComplete: async ({ reason, transaction }) => {
            if (reason === window.FedaPay.CHECKOUT_COMPLETED) {
              try {
                if (id !== undefined) {
                  await updateVendeurInfo(id, {
                    plan: true,
                    type_plan: "payant"
                  });
                  console.log("Mise à jour du plan réussie");
                  
                  // Sauvegarder les données de transaction
                  await saveTransactionData(transaction?.id || 'fedapay-transaction', montant, id);
                }
                navigate("/PaymentStatusFedapay");
              } catch (error) {
                console.error("Erreur lors de la mise à jour:", error);
                navigate("/PaymentStatusFedapayFalse");
              }
            } else if (reason === window.FedaPay.DIALOG_DISMISSED) {
              console.log("Le dialogue de paiement a été fermé par l'utilisateur.");
              navigate("/PaymentStatusFedapayFalse");
            }
          },
        });

        widget.open();
      } catch (error) {
        console.error("Erreur lors de l'initialisation de FedaPay:", error);
        setStatus({
          type: 'error',
          message: 'Erreur lors de l\'initialisation du paiement FedaPay'
        });
      } finally {
        setLoading(false);
      }
    } else if (selectedAggregator.name === 'monero') {
      // Utiliser handleSubmit pour Monero
      handleSubmit(e);
    } else {
      // Pour les autres méthodes de paiement
      handleSubmit(e);
    }
  };

  //handleClick()

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-gray-800">Paiement Sécurisé</h2>
          <p className="text-gray-600">Remplissez les informations pour procéder au paiement</p>
          {selectedAggregator && (
            <div className="mt-2 bg-blue-50 rounded-md p-2">
              <p className="text-sm text-blue-600">
                Méthode: <span className="font-semibold">{selectedAggregator.name}</span>
              </p>
              <p className="text-xs text-blue-500 mt-1">
                {selectedAggregator.apiUrl && `API: ${selectedAggregator.apiUrl}`}
              </p>
            </div>
          )}
        </div>

        <form onSubmit={handleClick} className="space-y-6">
          

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <div className="relative">
              <Mail className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
              <input
                type="email"
                name="email"
                className="pl-10 w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="votre@email.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

         

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white p-3 rounded-md font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {loading ? 'Traitement...' : 'Payer Maintenant'}
          </button>
        </form>

        {status && (
          <div className={`mt-4 p-4 rounded-md ${status.type === 'error' ? 'bg-red-50 text-red-700' : 'bg-green-50 text-green-700'}`}>
            {status.message}
          </div>
        )}
      </div>
    </div>
  );
};

export default IndexPaiement;